import throttle from 'lodash.throttle';

export const resizeHooks = new Set();
window.resizeHooks = resizeHooks;
export const registerResizeHandler = (fn) => resizeHooks.add(fn);
export const unregisterResizeHandler = (fn) => resizeHooks.delete(fn);
const runAllHooks = throttle(() => resizeHooks.forEach((fn) => fn()), 100);
window.addEventListener('resize', runAllHooks, {
    capture: true,
    passive: true
});
